export default "__VITE_ASSET__C0et556g__"